import { useEffect } from "react";
import {
  getTotalFixedCostYear1,
  getTotalFixedCostYear2,
  getTotalFixedCostYear3,
} from "../Redux/Actions/totalFixedCostPerYear";

export const AmountsFixedCostPerYear = (fixedCostData, dispatch) => {
  //#region add all amounts in "Fasta kostnader", per year
  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      function addTotalFixedCostPerYear(year) {
        try {
          const total =
            fixedCostData?.fixedCostData
              .filter((item) => item.year === year)
              .map((item) => item.object.amount)
              //add sum of each row
              .reduce((acc, curr) => acc + parseInt(curr, 10), 0);
          if (year === "year1") {
            dispatch(getTotalFixedCostYear1(total));
          }
          if (year === "year2") {
            dispatch(getTotalFixedCostYear2(total));
          }
          if (year === "year3") {
            dispatch(getTotalFixedCostYear3(total));
          }
        } catch (err) {}
      }
      addTotalFixedCostPerYear("year1");
      addTotalFixedCostPerYear("year2");
      addTotalFixedCostPerYear("year3");
    }
    return () => {
      isMounted = false;
    };
  }, [dispatch, fixedCostData]);
  //#endregion add all amounts in fixed cost, per year
};
